<template>

    <tabs-main
        v-model="activeTab"
        class="c-visit_edit"
        :validator="$validator"
        @submit="$emit('submit')"
        @submit-error="showError"
        :end-btn-label="value.status === 'started' ? 'Oznacz wizytę jako zakończoną' : null"
        :end-btn-hint="(p1IntegrationActive && value.status === 'started') ? 'Wizyta zostanie przesłana do Systemu P1' : null"
        :date-time="value.created_at"
        specific-nav>
        <tabs-item title="Wywiad">

            <p class="c-visit_edit__reason">Powód wizyty:</p>
            <p class="c-visit_edit__issue">{{ value.issue.name }}</p>

            <visit-field-text
                v-model="value.issue_status"
                title="Opis historii problemu"
                label="Dodaj bieżący opis historii problemu"
                name="issue_status">
            </visit-field-text>

            <visit-field-tags
                v-model="value.accompanying_diseases"
                title="Choroby towarzyszące"
                label="Dodaj towarzyszące schorzenia"
                name="accompanying_diseases">
            </visit-field-tags>

            <visit-field-text
                v-model="value.family_interview"
                title="Wywiad rodzinny"
                label="Opis historii choroby w rodzinie pacjenta"
                name="family_interview">
            </visit-field-text>

            <visit-field-tags
                v-model="value.activities_generating_problem"
                title="Aktywności generujące ból lub problem"
                label="Dodaj aktywności"
                name="activities_generating_problem">
            </visit-field-tags>

            <visit-field-text
                v-model="value.movement_disorder"
                title="Zaburzenia funkcji ruchu lub fizjologicznych"
                label="Opis zaburzeń"
                name="movement_disorder">
            </visit-field-text>

            <visit-field-tags
                v-model="value.factors_causing_deterioration"
                title="Czynniki powodujące pogorszenie stanu pacjenta"
                label="Dodaj czynniki"
                name="factors_causing_deterioration">
            </visit-field-tags>

            <visit-field-tags
                v-model="value.factors_causing_improvement"
                title="Czynniki powodujące polepszenie stanu pacjenta"
                label="Dodaj czynniki"
                name="factors_causing_improvement">
            </visit-field-tags>

            <visit-field-tags
                v-model="value.taken_medicines"
                title="Przyjmowane leki"
                label="Dodaj leki"
                name="taken_medicines">
            </visit-field-tags>

            <visit-field-text
                v-model="value.additional_information"
                title="Informacje dodatkowe"
                label="Opis dodatkowych informacji nieujętych wcześniej"
                name="additional_information">
            </visit-field-text>
        </tabs-item>

        <tabs-item title="Badania fizykalne">

            <visit-field-text
                v-model="value.range_of_motion"
                title="Zakres ruchu"
                label="Dodaj opis o zakresie ruchu"
                name="range_of_motion">
            </visit-field-text>

            <visit-field-text
                v-model="value.muscular_strength"
                title="Siła mięśniowa"
                label="Dodaj opis o sile mięśniowej"
                name="muscular_strength">
            </visit-field-text>

            <visit-field-text
                v-model="value.circuit_measurement"
                title="Pomiar obwodów"
                label="Dodaj pomiary obwodów"
                name="circuit_measurement">
            </visit-field-text>
            <visit-field-pain-map
                v-model="value.map_of_pain"
                title="Mapa bólu"
                label="Zaznacz punkty na mapie ciała i dodaj do nich opisy"
                name="map_of_pain">
            </visit-field-pain-map>
        </tabs-item>

        <tabs-item title="Rozpoznanie">

            <visit-field-text
                v-model="value.recognition"
                title="Rozpoznanie"
                label="Opis rozpoznania lekarskiego"
                name="recognition">
            </visit-field-text>

            <visit-field-tags-select
                v-model="value.recognition_icd10"
                title="Rozpoznania ICD-10"
                label="Wybierz odpowiednie kody ICD-10"
                name="recognition_icd10"
                ajax-url="/visits/icd10-codes"
                :format-item="function (item) {
                    console.log('templateResult');
                    return item.id + ' - ' + item.text;
                }">
            </visit-field-tags-select>

        </tabs-item>

        <tabs-item title="Przebieg terapii">
            <visit-field-text
                v-model="value.therapy_being_performed"
                title="Wykonywane terapie"
                label="Opis wykonywanej terapii"
                name="therapy_being_performed">
            </visit-field-text>

            <visit-field-tags-select
                v-model="value.procedures_icd9"
                title="Procedury ICD-9"
                label="Wybierz odpowiednie kody ICD-9"
                name="procedures_icd9"
                ajax-url="/visits/icd9-codes"
                :format-item="function (item) {
                    console.log('templateResult');
                    return item.id + ' - ' + item.text;
                }">
            </visit-field-tags-select>

            <visit-field-tags
                v-model="value.exercises"
                title="Ćwiczenia z pacjentem"
                label="Dodaj ćwiczenia"
                name="exercises">
            </visit-field-tags>

            <visit-field-text
                v-model="value.attention_to_exercises"
                title="Uwagi do ćwiczeń"
                label="Opis uwag i wskazówek dla pacjenta"
                name="attention_to_exercises">
            </visit-field-text>

            <visit-field-list
                v-model="value.plan_of_works"
                title="Plan działań na przyszłą wizytę"
                label="Dodaj zadania"
                name="plan_of_works">
            </visit-field-list>
        </tabs-item>

        <tabs-item title="Zalecenia dla pacjenta">
            <visit-field-text
                v-model="value.recommendations"
                title="Zalecenia dla pacjenta"
                label="Opis zaleceń dla pacjenta"
                name="recommendations">
            </visit-field-text>

            <visit-field-videos
                v-model="value.videos_with_exercises"
                title="Linki do filmów z ćwiczeniami"
                label="Wklej link do filmu z YouTube"
                name="videos_with_exercises">
            </visit-field-videos>

            <visit-field-email
                v-model="value.patient_email_for_recommendations"
                title="Wyślij zalecenia do pacjenta"
                label="Adres e-mail pacjenta"
                switch-label="Wyślij zalecenia do pacjenta"
                name="patient_email_for_recommendations">
            </visit-field-email>
        </tabs-item>

        <tabs-item title="Załączniki">
            <visit-field-attachments
                v-model="visitAttachmentsFormal"
                title="Dokumenty formalne"
                type="formal-documents">
            </visit-field-attachments>

            <visit-field-attachments
                v-model="visitAttachmentsDiagnostic"
                title="Badania diagnostyczne"
                type="diagnostic-tests">
            </visit-field-attachments>
        </tabs-item>

        <tabs-item v-if="cfs && cfs.length" title="Pola niestandardowe">
            <visit-field-custom-field
                v-for="(cf, index) in cfs"
                :key="index"
                v-model="cf.content"
                :title="cf.key"
                name="custom_fields">
            </visit-field-custom-field>
        </tabs-item>
    </tabs-main>

</template>

<script>

import {mapGetters} from 'vuex'
import noReact from 'Utils/NoReact'

import {
    VisitFieldTags,
    VisitFieldTagsSelect,
    VisitFieldText,
    VisitFieldList,
    VisitFieldPainMap,
    VisitFieldEmail,
    VisitFieldVideos,
    VisitFieldAttachments,
    VisitFieldCustomField
} from 'Components/Visit/Fields'

import {
    TabsMain,
    TabsItem,
    TabsSection
} from 'Components/Tabs'

export default {

    name: 'VisitForm',

    props: {
        value: Object
    },

    data() {
        return {
            activeTab: 0
        }
    },

    computed: {
        ...mapGetters(['pht', 'patient', 'visitAttachmentsFormal', 'visitAttachmentsDiagnostic']),
        cfs() {
            if (this.value.custom_fields === null) {
                this.value.custom_fields = []
                var _cfs = []
                const len = this.pht.custom_fields.length
                for (let i = 0; i < len; i++) {
                    let fieldName = this.pht.custom_fields[i]
                    _cfs.push({
                        key: fieldName,
                        content: this.getCFValue(fieldName)
                    })
                }
                this.value.custom_fields = _cfs
                return _cfs
            }

            return this.value.custom_fields
        },
        p1IntegrationActive() {
            return this.$auth.user().p1_integration_settings && this.$auth.user().p1_integration_settings.integration_enabled
        }
    },
    methods: {
        checkValid(scope) {
            return this.$validator.validateAll(scope)
        },
        showError() {
            this.$alert.error('Przebieg wizyty', 'Popraw błędy w formularzu aby zapisać zmiany.')
        },
        getCFValue(key) {
            if (this.value.custom_fields === null)
                this.value.custom_fields = []

            const cf = this.value.custom_fields.filter((f) => {
                return f.key === key
            })
            return cf.length ? cf[0].content : null
        }
    },

    components: {
        TabsMain,
        TabsItem,
        TabsSection,
        VisitFieldTags,
        VisitFieldTagsSelect,
        VisitFieldText,
        VisitFieldList,
        VisitFieldPainMap,
        VisitFieldEmail,
        VisitFieldVideos,
        VisitFieldAttachments,
        VisitFieldCustomField
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-visit_edit {
    &__reason {

    }

    &__issue {
        color: $c-third;
        font-size: 1.4rem;
        margin-bottom: 3rem;
    }
}

</style>
